import {createSelector, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {TestApiResponse, TestItem, TestPagination} from "../../types/test/TestSchema";
import {Pagination} from "features/model/types/groups/groupsLessonsSchema";
import {RootState} from "app/store";


interface TestState {
    tests: TestItem[];
    pagination: TestPagination;
    isLoading: boolean;
}

const testsSlice = createSlice({
    name: "tests",
    initialState: {
        tests: [],
        pagination:{} as Pagination,
        isLoading: true,
    } as TestState,
    reducers: {
        setTests: (state, action: PayloadAction<TestApiResponse>) => {
            const { data } = action.payload;
            state.tests = data.items;
            state.pagination = data.pagination;
            state.isLoading = false;
        },
        setLoading: (state, action: PayloadAction<{ isLoading:boolean }>) => {
            state.isLoading = action.payload.isLoading;
        },
    },
});

export const { setTests, setLoading } = testsSlice.actions;
export const testsReducer = testsSlice.reducer;

export const selectPagination = createSelector(
    (state: RootState) => state.test.pagination,
    (pagination) => pagination
);
